



















































import BaseFormMixin from '@/mixins/base-form-mixin';
import IndicatorServices from '@/services/indicator';
import SubjectServices from '@/services/subject';
import { mixins } from 'vue-class-component';
import { Component, PropSync, Prop, Watch } from 'vue-property-decorator';
@Component
export default class IndDefinition extends mixins(BaseFormMixin) {
  @PropSync('ind') syncIndDefinition!: any;
  @Prop() formData!: any;

  subjectSrv = new SubjectServices();
  indSrv = new IndicatorServices();

  options: any = [];

  async created() {
    await this.getSubList();
    if (this.formData.id) {
      this.initEdit();
    }
  }

  initEdit() {
    this.indDefinition = this.syncIndDefinition;
    this.indSubs = this.syncIndDefinition.indSubs ? this.syncIndDefinition.indSubs : this.indSubs;
    this.mesValue.push(`${this.indDefinition.subCategoryName}`);
    this.mesValue.push(`${this.indDefinition.subCode}/${this.indDefinition.subName}`);
    this.mesValue.push(`${this.indDefinition.mesFieldCode}/${this.indDefinition.mesFieldName}`);
    this.changeMes(this.mesValue);
    this.indSubs.forEach((v: any, index: number) => {
      if (index > 0) this.changeSubField1(v.dimFieldCode, index);
    });
  }

  subInfo: any = '';
  subList: any = [];
  async getSubList() {
    let tree = await this.subjectSrv.getTree({ status_eq: 0, approveStatus_ge: 4, approveStatus_le: 5 });
    this.options = this.transTreeData(tree);
  }

  subFieldList: any = [];
  subFieldList0: any = [];
  subFieldList1: any = [];
  subFieldList2: any = [];
  mesValue: string[] = [];
  changeMes(e: string[]) {
    let [category, sub, mes] = e;
    let [subCategoryName] = category.split('/');
    let [subCode, subName] = sub.split('/');
    let [mesFieldCode, mesFieldName] = mes.split('/');
    // this.indDefinition.subCategoryId = subCategoryId;
    this.indDefinition.subCategoryName = subCategoryName;
    // this.indDefinition.subId = subId;
    this.indDefinition.subCode = subCode;
    this.indDefinition.subName = subName;
    // this.indDefinition.mesFieldId = mesFieldId;
    this.indDefinition.mesFieldCode = mesFieldCode;
    this.indDefinition.mesFieldName = mesFieldName;

    this.subFieldList0 = this.fieldDateList[subCode];
    this.subFieldList1 = this.fieldDimList[subCode];
    this.changeSyncDefInfo();
  }
  // 数据期
  changeDateType(e: string, k: number) {
    let item = this.DICT_DATE_TYPE.find((v: any) => v.value === e);
    this.indSubs[k].refDimFieldName = item.dictItemName;
    this.indSubs[k].refDimFieldCode = item.dictItemCode;
    this.indSubs[k].refDimCode = item.dictCode;
  }
  // 数据期
  changeSubField0(fieldCode: string, k: number) {
    let field = this.subFieldList0.find((v: any) => v.fieldCode === fieldCode);
    this.indSubs[k].dimFieldCode = field.fieldCode;
    this.indSubs[k].dimFieldId = field.id;
    this.indSubs[k].dimFieldName = field.fieldName;
  }
  // 维度值
  changeSubField1(fieldCode: string, k: number) {
    let field = this.subFieldList1.find((v: any) => v.fieldCode === fieldCode);
    this.indSubs[k].dimFieldCode = field.fieldCode;
    this.indSubs[k].dimFieldId = field.id;
    this.indSubs[k].dimFieldName = field.fieldName;

    this.indSubs[k].refDimFieldCode = field.fieldCode;
    this.indSubs[k].refDimFieldName = field.fieldName;
    this.indSubs[k].refDimCode = field.refDimCode;

    this.getEsData(field.refDimCode, field.fieldCode, k);
    this.changeSyncDefInfo();
  }

  dimInfo: any = [];
  dimValueList: any[] = [];
  async getEsData(dimCode: string, dimFieldCode: string, k: number) {
    let subCode = this.indDefinition.subCode;
    let obj: object = await this.indSrv.getDimData({ subCode, subFieldCode: dimFieldCode });
    this.$set(this.dimValueList, k, obj);
    console.log(this.dimValueList);
  }

  indSubs = [
    {
      dimFieldCode: '',
      dimFieldId: 0,
      dimFieldName: '',
      refDimType: 'DICT',
      indCode: this.formData.indCode,
      refDimCode: '',
      refDimFieldCode: '',
      refDimFieldName: '',
      refDimFieldValue: '',
      refDimName: '',
      subComparator: ''
    }
  ];
  addConf() {
    this.indSubs.push({
      dimFieldCode: '',
      dimFieldId: 0,
      dimFieldName: '',
      refDimType: 'DIM',
      indCode: this.formData.indCode,
      refDimCode: '',
      refDimFieldCode: '',
      refDimFieldName: '',
      refDimFieldValue: '',
      refDimName: '',
      subComparator: ''
    });
  }
  removeConf(k: number) {
    this.indSubs.splice(k, 1);
  }

  // 根指标
  indDefinition: any = {
    aggOperator: '',
    indSubs: [],
    mesFieldCode: '',
    mesFieldId: 0,
    mesFieldName: '',
    subCategoryId: 0,
    subCategoryName: '',
    subCode: '',
    subId: 0,
    subName: ''
  };

  @Watch('indDefinition')
  onIndDefinitionChange() {
    this.changeSyncDefInfo();
  }

  @Watch('indSubs')
  onIndSubsChange() {
    this.changeSyncDefInfo();
  }

  changeSyncDefInfo() {
    this.syncIndDefinition = this.indDefinition;
    this.syncIndDefinition.indSubs = this.indSubs;
  }

  fieldDateList: any = {};
  fieldDimList: any = {};
  private transTreeData(tree: any) {
    return tree.map((v: any) => {
      return {
        value: `${v.categoryName}`,
        label: v.categoryName,
        children: v.leafList.map((v2: any) => {
          this.fieldDateList[v2.subCode] = v2.fieldDateList;
          this.fieldDimList[v2.subCode] = v2.fieldDimList;
          return {
            label: v2.subName,
            value: `${v2.subCode}/${v2.subName}`,
            children: v2.fieldMesList.map((v3: any) => ({
              label: v3.fieldName,
              value: `${v3.fieldCode}/${v3.fieldName}`
            }))
          };
        })
      };
    });
  }
}
